import { DEFAULT_LOCATION, DEFAULT_USER_LOCATION } from '@/constants/location'
import { type UserLocation } from '@/generated/graphql-types'
import { type GlobalLocation } from '@/lib/apollo/locationCache'
import { getLatestSearchCookieValues } from '@/utils/cookies/latestSearchCookie'

import { convertCookieToGlobalLocation } from './convertCookieToGlobalLocation'
import { convertCookieToUserLocation } from './convertCookieToUserLocation'

/**
 * Set initial location data from latest search cookie,
 * then save to reactive var in apollo cache
 */
export const getInitialLocation = async (
  userPreferenceCookie?: string
): Promise<GlobalLocation> => {
  const latestSearch = getLatestSearchCookieValues(userPreferenceCookie)

  /**
   * Set location as "allCanada" if no cookie was ever set
   * Set cookies + global var
   *  */
  if (!latestSearch) {
    return DEFAULT_LOCATION
  }

  /** If there is a location cookie set - update reactive var based on that */
  const locationVar = await convertCookieToGlobalLocation(latestSearch)
  return locationVar
}

/**
 * Returns the initial location data from latest search cookie
 * If none found, returns the default location
 */
export const getInitialUserLocation = (userPreferenceCookie?: string): UserLocation => {
  const latestSearch = getLatestSearchCookieValues(userPreferenceCookie)

  /**
   * Set location as "allCanada" if no cookie was ever set
   */
  if (!latestSearch) {
    return DEFAULT_USER_LOCATION
  }

  /** If there is a location cookie set - update reactive var based on that */
  const location = convertCookieToUserLocation(latestSearch)
  return location
}
